import React from "react";
import "./assets/css/App.css";
import ExcelComparator from "./components/ExcelComparator";

const App = () => {
  return (
    <div className="App">
      <ExcelComparator />
    </div>
  );
};

export default App;
